import { IPricelistFilterConfig } from '../../types';
import { IFilterState } from 'src/areas/product/types';
import {
  SortOptionEnum,
  PriceDisplayEnum,
} from 'src/components/price-list/types';
import { getLocalStorageItem, setLocalStorageItem } from './local-storage';
import { ClientMarket } from '@prisjakt/web-app-config/types/client-market';

const storageKey = 'pj:userOfferlistOptions';

export function saveFiltersAsUserSettings(filters: IFilterState) {
  let options = getLocalStorageItem<IStoredUserSettings>(storageKey);
  if (options !== undefined) {
    options.filters = filters;
  } else {
    options = { filters: { ...filters } };
  }

  setLocalStorageItem(storageKey, options);
}

export function savePriceDisplayAsUserSettings(priceDisplay: PriceDisplayEnum) {
  let options = getLocalStorageItem<IStoredUserSettings>(storageKey);
  if (options !== undefined) {
    options.priceDisplay = priceDisplay;
  } else {
    options = { priceDisplay };
  }
  setLocalStorageItem(storageKey, options);
}

export function saveSortingAsUserSettings(sorting: SortOptionEnum) {
  let options = getLocalStorageItem<IStoredUserSettings>(storageKey);
  if (options !== undefined) {
    options.sorting = sorting;
  } else {
    options = { sorting };
  }
  setLocalStorageItem(storageKey, options);
}

export function getFiltersFromUserSettings(filters: IFilterState) {
  const storedFilters = getLocalStorageItem<IStoredUserSettings>(storageKey);
  const newFilters = { ...filters };

  if (storedFilters) {
    Object.keys(newFilters).forEach(key => {
      const readVal = storedFilters.filters?.[key];
      if (readVal !== null && readVal !== undefined) {
        newFilters[key] = readVal;
      }
    });
  }

  return newFilters;
}

export function getPriceDisplayFromUserSettings() {
  return getLocalStorageItem<IStoredUserSettings>(storageKey)?.priceDisplay;
}

export function getSortingFromUserSettings() {
  return getLocalStorageItem<IStoredUserSettings>(storageKey)?.sorting;
}

export function getNumberOfActiveFilters(
  filters: IFilterState,
  filtersConfig: IPricelistFilterConfig[]
): number {
  return filtersConfig.reduce((counter: number, current: any) => {
    if (filters[current.name] === true && !current.hide) {
      return counter + 1;
    }
    return counter;
  }, 0);
}

export const defaultHiddenListOptions = (market: ClientMarket) => {
  return market.priceList && market.priceList.hiddenListOptions
    ? [...market.priceList.hiddenListOptions]
    : [];
};
interface IStoredUserSettings {
  filters?: IFilterState;
  priceDisplay?: PriceDisplayEnum;
  sorting?: SortOptionEnum;
}
